import React, { Fragment, useCallback, useContext } from 'react';
import { useNavigate, useLocation, NavLink } from 'react-router-dom';
import { deleteCookie } from '../../common-service/CommonService';
import { postLogout } from '../../api/Api';
import { StoreContext } from '../../context/StoreContext';
import './ViewContainer.css';

const ViewContainer = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoggedIn, setIsLoggedIn, setUser } = useContext(StoreContext);
  const isLoginPage = location.pathname === '/login';

  /**
   * Prevents adding duplicate history entries when clicking a nav link
   * that points to the page you're already on.
   */
  const handleNavClick = useCallback(
    (to) => (e) => {
      if (location.pathname === to) {
        e.preventDefault();
      }
      closeNavbar();
    },
    [location.pathname],
  );

  const onLogout = (e) => {
    e.preventDefault();
    if (isLoggedIn) {
      postLogout().catch(() => {});
      sessionStorage.clear();
      deleteCookie('token');
      setIsLoggedIn(false);
      setUser(null);
      navigate('/login');
    } else {
      navigate('/login');
    }
  };

  const getMenuPath = () => '/menu/' + user?.nameEn?.replaceAll(' ', '_');

  const closeNavbar = () => {
    const navbarCollapse = document.getElementById('navbarSupportedContent');
    if (navbarCollapse) {
      window.bootstrap?.Collapse?.getOrCreateInstance(navbarCollapse).hide();
    }
  };

  return (
    <Fragment>
      {isLoggedIn ? (
        <nav className="app-navbar navbar navbar-expand-lg navbar-light bg-light">
          <div className="container-fluid">
            <span className="navbar-brand small text-muted" style={{ opacity: 0.5 }}>
              Menu System
            </span>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                {user?.id && !user?.is_admin && (
                  <>
                    <li className="nav-item">
                      <NavLink
                        className="nav-link"
                        to="/profile"
                        onClick={handleNavClick('/profile')}
                      >
                        Profile
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav-link"
                        to={getMenuPath()}
                        onClick={handleNavClick(getMenuPath())}
                      >
                        Menu
                      </NavLink>
                    </li>
                  </>
                )}
                {Boolean(user?.is_admin) === true && (
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      to="/dashboard"
                      onClick={handleNavClick('/dashboard')}
                    >
                      Dashboard
                    </NavLink>
                  </li>
                )}
                <li className="nav-item">
                  <button
                    className="nav-link btn btn-link"
                    onClick={(e) => {
                      closeNavbar();
                      onLogout(e);
                    }}
                  >
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      ) : (
        <nav className="app-navbar navbar navbar-expand-lg navbar-light bg-light">
          <div className="container-fluid">
            <span
              className="navbar-text small text-muted"
              style={{ fontSize: '0.85rem', opacity: 0.5 }}
            >
              Menu System
            </span>
            {!isLoginPage && (
              <NavLink
                to="/login"
                className="nav-link small login-nav-link"
                style={{ fontSize: '0.8rem', cursor: 'pointer' }}
              >
                <i className="fas fa-sign-in-alt" style={{ marginRight: 4 }} /> Login
              </NavLink>
            )}
          </div>
        </nav>
      )}
      {children}
    </Fragment>
  );
};

export default ViewContainer;
